export default __webpack_public_path__ + "img/InterDisplay-ExtraBoldItalic_a44583d.woff2";